module.exports = __webpack_public_path__ + "media/images/mobile/border_q-3c6e456570b53ac3b325c8200edc9ebc.gif";